import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DataTable, num } from "@/lib/admin";
import { PageHead } from "@/pages/admin/AdminLayout";
import { Dashboard } from "@/components/admin/Dashboard";
import { FilterBar, ALL_FILTERS, SEDE_FILTERS } from "@/components/admin/FilterBar";
import { Loading } from "@/components/layout/RequireAuth";
import { ReportButtons } from "@/components/admin/ReportButtons";
import { usePageTitle } from "@/components/layout/AppLayout";

export const Panoramica = () => {
    const { user } = useAuth();
    const [title, setTitle] = useState("");
    useEffect(() => { api.get("/admin/overview").then(({ data }) => setTitle(data.title)); }, []);
    usePageTitle(title || "Panoramica");
    if (!title) return <Loading />;
    const sede = user.role === "admin_sede";
    return (
        <>
            <PageHead title={title}><ReportButtons section="panoramica" drop={["q", "sort", "dir"]} /></PageHead>
            {sede && <FilterBar keys={SEDE_FILTERS} version={false} />}
            <Dashboard />
        </>
    );
};

export const Analisi = () => {
    usePageTitle("Analisi dettagliata");
    return (<><PageHead title="Analisi dettagliata"><ReportButtons section="analisi" drop={["q", "sort", "dir"]} /></PageHead><FilterBar keys={ALL_FILTERS} /><Dashboard /></>);
};

const LEVELS = ["Principiante", "Esploratore", "Praticante", "Avanzato"];

const TerritoryTable = ({ caption, rows, testId, onOpen }) => {
    const [sort, setSort] = useState({ key: "label", dir: "asc" });
    const val = (r, k) => (LEVELS.includes(k) ? r.levels[k] : r[k]);
    const sorted = [...rows].sort((a, b) => {
        const x = val(a, sort.key) ?? -1, y = val(b, sort.key) ?? -1;
        const c = typeof x === "string" ? x.localeCompare(y) : x - y;
        return sort.dir === "asc" ? c : -c;
    });
    const onSort = (k) => setSort((s) => ({ key: k, dir: s.key === k && s.dir === "asc" ? "desc" : "asc" }));
    return (
        <DataTable caption={caption} testId={testId} rows={sorted} sort={sort} onSort={onSort} onRowClick={onOpen} columns={[
            { key: "label", label: caption.includes("Regione") ? "Regione" : "Sede SPIN" },
            { key: "aziende", label: "Aziende registrate" },
            { key: "con_assessment", label: "Con assessment", render: (r) => `${r.con_assessment} (${num(r.pct_con_assessment)}%)` },
            { key: "punteggio_medio", label: "Punteggio medio", render: (r) => num(r.punteggio_medio) },
            ...LEVELS.map((l) => ({ key: l, label: l, render: (r) => r.levels[l] })),
        ]} />
    );
};

export const Territori = () => {
    usePageTitle("Confronto territori");
    const navigate = useNavigate();
    const [d, setD] = useState(null);
    useEffect(() => { api.get("/admin/territories").then(({ data }) => setD(data)); }, []);
    if (!d) return <Loading />;
    return (
        <>
            <PageHead title="Confronto territori"><ReportButtons section="territori" /></PageHead>
            <div className="space-y-6">
                <TerritoryTable caption="Per Regione" rows={d.regioni} testId="territori-regioni" onOpen={(r) => navigate(`/amministrazione/analisi?regione=${encodeURIComponent(r.key)}`)} />
                <TerritoryTable caption="Per Sede SPIN" rows={d.sedi} testId="territori-sedi" onOpen={(r) => navigate(`/amministrazione/analisi?spin=${encodeURIComponent(r.key)}`)} />
            </div>
        </>
    );
};
